import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ArrayFunctions } from '@campus/utils';
import { Observable } from 'rxjs';
import { BearerHttpService } from '../bearer-http';
import { DAL_OPTIONS, DalOptions } from '../dal.module';
import { WordInterface } from './word.interface';
import { WordServiceInterface } from './word.service.interface';
const { wrapIntoArray } = ArrayFunctions;

@Injectable({
  providedIn: 'root',
})
export class WordService implements WordServiceInterface {
  private bearerHttpService = inject(BearerHttpService);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private apiV2BaseUrl = this.dalOptions.apiV2BaseUrl;

  getWords(
    searchTerm: string,
    filters: { [key: string]: string | number | number[] } = {},
    pagination: { from?; amount? } = {},
    columns: string[] = null,
    sorting: { [key: string]: 'asc' | 'desc' } = {}
  ): Observable<{ results: object[]; count: number }> {
    const url = `${this.apiV2BaseUrl}/word`;
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters),
        columns: JSON.stringify(columns),
        sorting: JSON.stringify(sorting),
        pagination: JSON.stringify(pagination),
      },
    });

    return this.bearerHttpService.get<{ results: object[]; count: number }>(url, params);
  }

  createWordForBook(publicationId: number, data: object): Observable<WordInterface> {
    const url = `${this.apiV2BaseUrl}/word/publications/${publicationId}`;
    return this.bearerHttpService.post<WordInterface>(url, data);
  }

  destroyWord(id: number): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word/${id}`;

    return this.bearerHttpService.delete<void>(url);
  }

  createWord(tocEntryId: number, data: object): Observable<WordInterface> {
    const url = `${this.apiV2BaseUrl}/word/${tocEntryId}`;

    return this.bearerHttpService.post<object>(url, data);
  }

  updateWord(id: number, data: object): Observable<WordInterface> {
    const url = `${this.apiV2BaseUrl}/word/${id}`;

    return this.bearerHttpService.patch<object>(url, data);
  }

  getWord(id: number): Observable<WordInterface> {
    const url = `${this.apiV2BaseUrl}/word/${id}`;

    return this.bearerHttpService.get(url);
  }

  uploadImage(imageData: string): Observable<{ url: string }> {
    const url = `${this.apiV2BaseUrl}/word/image`;
    return this.bearerHttpService.post<{ url: string }>(url, { imageData });
  }

  publish(wordId: number | number[], wordSetId: number): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word/publish`;
    const body = { wordSetId, wordIds: wrapIntoArray(wordId) };
    return this.bearerHttpService.post(url, body);
  }

  unpublish(wordId: number | number[], wordSetId: number): Observable<void> {
    const url = `${this.apiV2BaseUrl}/word/unpublish`;
    const body = { wordSetId, wordIds: wrapIntoArray(wordId) };
    return this.bearerHttpService.post(url, body);
  }
}
